import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import NavLink from "./NavLink/NavLink";
import { Link } from "react-router-dom";
import Logo from "../../../assets/icons/logo.svg";
import { useDispatch, useSelector } from "react-redux";
import { sidebarActions } from "../../../store/sidebar-slice";
import liveAdsIcon from "../../../assets/icons/live ads.svg";
import HomeIcon from "../../../assets/icons/HomeIcon.svg";
import Home1Icon from "../../../assets/icons/Home1.svg";
import CampaignIcon from "../../../assets/icons/CampaignIcon.svg";
import Campaign1Icon from "../../../assets/icons/Campaign1.svg";
import AdsIcon from "../../../assets/icons/Ads.svg";
import Ads1Icon from "../../../assets/icons/Ads1.svg";
import ProductIcon from "../../../assets/icons/Product.svg";
import Product1Icon from "../../../assets/icons/Product2.svg";
import SettingsIcon from "../../../assets/icons/Settings.svg";
import Settings1Icon from "../../../assets/icons/Settings1.svg";
import { stepsActions } from "../../../store/steps-slice";

const Sidebar = () => {
  const [toggleSidebar, setToggleSidebar] = useState(true);
  const dispatch = useDispatch();
  const showSidebar = useSelector((state) => state.sidebar.showSidebar);
  const route = useSelector((state) => state.sidebar.route);

  function handleToggleSideBar() {
    setToggleSidebar(!toggleSidebar);
  }

  function handleRouteChange(route) {
    dispatch(stepsActions.resetSteps());
    dispatch(sidebarActions.setRoute(route));
  }
  
  useEffect(() => {
    dispatch(sidebarActions.setRoute(window.location.pathname));
  }, [dispatch, route]);

  return (
    <div className={`${!toggleSidebar && "sidebar-backdrop"}`}>
      <div id="sideBar" className={`${toggleSidebar ? "sideBarRes" : "sideBarResOpen"} ${showSidebar ? "" : "sideBarHide"}`}>
        <img src={Logo} alt="logo" className="logo" onClick={handleToggleSideBar} />
        <ul className={`nav-links ${toggleSidebar ? "nav-linksRes" : ""}`}>
          <Link to="/" className="campaignLink" onClick={(e) => handleRouteChange("/")}>
            <NavLink src={route === "/" ? Home1Icon : HomeIcon} selected={route === "/" ? "nav-link-selected" : ""} navLinkName="Home" />
          </Link>
          <Link to="/campaign" className="campaignLink" onClick={(e) => handleRouteChange("/campaign")}>
            <NavLink src={route === "/campaign" ? Campaign1Icon : CampaignIcon} selected={route === "/campaign" ? "nav-link-selected" : ""} navLinkName="Campaign" />
          </Link>
          {/* <Link
            to="/live-ads"
            className="campaignLink"
            onClick={(e) => handleRouteChange("/live-ads")}
          >
            <NavLink
              src={
                route === "/live-ads"
                  ? Ads1Icon
                  : AdsIcon
              }
              selected={route === "/live-ads" ? "nav-link-selected" : ""}
              navLinkName="Live ads"
            />
          </Link> */}
          <Link to="/products" className="campaignLink" onClick={(e) => handleRouteChange("/products")}>
            <NavLink
              src={route === "/products" ? Product1Icon : ProductIcon}
              selected={route === "/products" || route === "/products/add-new-product" || route === "/products/update-product" ? "nav-link-selected" : ""}
              navLinkName="Products"
            />
          </Link>
          <Link to="/profile" className="campaignLink" onClick={(e) => handleRouteChange("/profile")}>
            <NavLink src={route === "/profile" ? Settings1Icon : SettingsIcon} selected={route === "/profile" ? "nav-link-selected" : ""} navLinkName="Profile" />
          </Link>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
